
// 
// Fetch config data from CMS
// 
export default defineNuxtPlugin(async (nuxtApp) => {
  const config = useRuntimeConfig()
  const { data } = await useFetch(`${config.public.cmsBase}/config`)
  nuxtApp.provide('configData', data.value)
})